export default "__VITE_ASSET___kz$yFiz__"